import React from 'react';

import PageTitle from '../../components/PageTitle';
import InfoBox from '../../components/InfoBox';
import {
  FormWrapper,
  FlexWrapper,
  SupportImgLarge,
  CenteredHeader,
  ContactMail,
} from '../styles';

import ExampleUrl from '../../assets/img/admin-handle.svg';

const LBControl = () => (
  <div>
    <PageTitle>
      {window.isBytesansokanSe
        ? 'Bytesansökan granskar'
        : 'Lägenhetsbyte granskar'}
    </PageTitle>
    <FormWrapper>
      <FlexWrapper flex="column" mobileColumn centered>
        <SupportImgLarge url={ExampleUrl} />
        <CenteredHeader>
          Ditt ärende hanteras av teamet på Bytesansökan
        </CenteredHeader>
        <ContactMail
          to={
            window.isBytesansokanSe
              ? 'kontakt@bytesansokan.se'
              : 'bytesansokan@lagenhetsbyte.se'
          }>
          {window.isBytesansokanSe
            ? 'kontakt@bytesansokan.se'
            : 'bytesansokan@lagenhetsbyte.se'}
        </ContactMail>
      </FlexWrapper>
    </FormWrapper>

    <InfoBox header="Vad händer nu?">
      <p>
        För att säkerställa att ett byte har så goda förutsättningar som möjligt
        görs alltid en objektiv bedömning utifrån samtliga inkomna underlag.
        Detta görs för att säkerställa att bytesparterna skall kunna känna sig
        trygga samt att säkerställa Bytesansökan som produkt/tjänst.
      </p>
      <p>
        I de fall Bytesansökan misstänker oegentligheter avslås ansökningen samt
        rapporteras till berörd hyresvärd.
      </p>
    </InfoBox>
  </div>
);

export default LBControl;



// WEBPACK FOOTER //
// ./src/views/LBControl/index.js